import { __decorate } from "tslib";
import { Directive, ElementRef, Injector, Input, Output, EventEmitter } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
let GroupsTreeRootDirective = class GroupsTreeRootDirective extends UpgradeComponent {
    groups;
    show;
    options;
    selectedGroups;
    selectedGroupsUpdated = new EventEmitter();
    constructor(elementRef, injector) {
        super('groupsTreeRoot', elementRef, injector);
    }
    static ctorParameters = () => [
        { type: ElementRef },
        { type: Injector }
    ];
    static propDecorators = {
        groups: [{ type: Input }],
        show: [{ type: Input }],
        options: [{ type: Input }],
        selectedGroups: [{ type: Input }],
        selectedGroupsUpdated: [{ type: Output }]
    };
};
GroupsTreeRootDirective = __decorate([
    Directive({
        selector: 'groups-tree-root'
    })
], GroupsTreeRootDirective);
export { GroupsTreeRootDirective };
